/**
 * Error de transporte del módulo, con el código HTTP a la vista.
 *
 * Sin el `status` no se puede distinguir "este registro todavía no existe" (404,
 * esperable al abrir un formulario nuevo) de "no estás autenticado" (401), y los
 * dos terminaban silenciados por el mismo `catch`.
 */
export class DynamicEntitiesHttpError extends Error {
    readonly status: number;
    readonly statusText: string;
    readonly url: string;

    constructor(message: string, response: { status: number; statusText: string; url?: string }) {
        super(message);
        this.name = 'DynamicEntitiesHttpError';
        this.status = response.status;
        this.statusText = response.statusText;
        this.url = response.url ?? '';
    }
}

export const isDynamicEntitiesHttpError = (error: unknown): error is DynamicEntitiesHttpError =>
    error instanceof DynamicEntitiesHttpError;
